function pad2(n) {
  return String(n).padStart(2, '0');
}

function formatHm(h, m) {
  // Match requested style: 11:30, 12:00, 1:00
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return `${hour12}:${pad2(m)}`;
}

function toMinutes(h, m) {
  return h * 60 + m;
}

function getSaudiMinutes(now = new Date()) {
  // Saudi is UTC+3 (no DST). Use fixed offset to avoid relying on device timezone.
  const saudiMs = now.getTime() + 3 * 60 * 60 * 1000;
  const d = new Date(saudiMs);
  return d.getUTCHours() * 60 + d.getUTCMinutes();
}

/**
 * Returns all delivery slot labels for the day (no expiry filtering).
 */
export function getAllDeliverySlotLabels() {
  const startMins = toMinutes(11, 30);
  const endMins = toMinutes(21, 0);
  const step = 30;

  const labels = [];
  let slotNo = 1;

  for (let mins = startMins; mins + step <= endMins; mins += step) {
    const slotStart = mins;
    const slotEnd = mins + step;

    const sh = Math.floor(slotStart / 60);
    const sm = slotStart % 60;
    const eh = Math.floor(slotEnd / 60);
    const em = slotEnd % 60;

    labels.push(`Slot ${slotNo} : ${formatHm(sh, sm)} - ${formatHm(eh, em)}`);
    slotNo += 1;
  }

  return labels;
}

/**
 * Returns delivery slot labels like:
 * "Slot 1 : 11:30 - 12:00" ... until 9 PM (21:00).
 * Expired slots are excluded if `now` is past the slot start time.
 */
export function getAvailableDeliverySlotLabels(now = new Date()) {
  const startMins = toMinutes(11, 30);
  const endMins = toMinutes(21, 0);
  const step = 30;

  const nowMins = getSaudiMinutes(now);

  const labels = [];
  let slotNo = 1;

  for (let mins = startMins; mins + step <= endMins; mins += step) {
    const slotStart = mins;
    const slotEnd = mins + step;
    if (nowMins >= slotStart) {
      slotNo += 1;
      continue;
    }

    const sh = Math.floor(slotStart / 60);
    const sm = slotStart % 60;
    const eh = Math.floor(slotEnd / 60);
    const em = slotEnd % 60;

    labels.push(`Slot ${slotNo} : ${formatHm(sh, sm)} - ${formatHm(eh, em)}`);
    slotNo += 1;
  }

  return labels;
}

